<template>
    <v-container id="DetalleReporte" style="padding-top: 80px !important" class="pt-5">
        <div v-if="showcargando" id="cargando" style="z-index: 600;" wire:loading
            class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center">
            <div class="loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4"></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>

        <v-card elevation="6" class="base-card-container pa-0 mt-4">
            <v-card-title class="pa-5 pb-3 primary">
                <p style="color: white;">Pendientes WhatsApp</p>

                <v-spacer></v-spacer>
            </v-card-title>
            <v-form>

                <v-card-text>
                    <v-row justify="center">
                        <v-col cols="12">

                            <template>
                                <div style="margin: auto;" class="d-flex d-sm-flex d-md-none">
                                    <v-expansion-panels class="my-4" v-model="panel" :popout="true" focusable multiple
                                                        :hover="true">
                                        <v-expansion-panel v-for="(pendiente, i) in pendientes" :key="i" text=""
                                                           title="" active-class="activotl" id="bruh">
                                            <v-expansion-panel-header class="text-center" color="primary">
                                                <template v-slot:default>
                                                    <span class="card-title-text" style="font-size:17px;">
                                                        <b>Teléfono:</b>{{
 `
                                                        ${pendiente.NumeroTel} `
                                                        }}
                                                    </span>
                                                    <span class="grow"> </span>
                                                    <span class="card-title-text" style="font-size:18px;">
                                                        <b>Fecha:</b> {{
`
                                                        ${pendiente.FechaRecibido} `
                                                        }}
                                                    </span>
                                                </template>
                                            </v-expansion-panel-header>
                                            <v-expansion-panel-content >
                                                <v-list nav dense>
                                                    <v-list-item-group color="primary">
                                                        <div style="margin: auto;">
                                                            <v-list-item v-for="(r, i) in pendiente.reportes" :key="i"
                                                                         @click="VerReporte(r)"
                                                                         :style="i % 2 ? 'background-color: rgba(169, 182, 255, 0.18);' : ''">

                                                                <v-list-item-content>
                                                                    <v-list-item-title class="text-center">
                                                                        <div class="grid" style="grid-template-columns: 40% 60%;">
                                                                            <span style="font-weight: bold;">Reporte</span>
                                                                            <span style="font-weight: bold;">Asistencia</span>
                                                                            <span>
                                                                                {{`${r.nrreporte}-${r.svindice}`}}
                                                                            </span>

                                                                            <span style="overflow: hidden;">{{r.tipoAsistencia}}</span>
                                                                        </div>
                                                                        <div class="grid" style="grid-template-columns: 40% 60%;">
                                                                            <span style="font-weight: bold;">Cliente</span>
                                                                            <span style="font-weight: bold;">Actor</span>

                                                                            <span style="overflow: hidden;">{{r.cliente}}</span>

                                                                            <span style="text-align: center;">
                                                                                {{ r.actor }}
                                                                            </span>
                                                                        </div>
                                                                    </v-list-item-title>
                                                                    <v-divider></v-divider>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                        </div>
                                                    </v-list-item-group>
                                                </v-list>
                                            </v-expansion-panel-content>

                                           

                                        </v-expansion-panel>
                                    </v-expansion-panels>
                                </div>


                                <div style="margin: auto;" class="d-none d-md-flex d-lg-flex d-xl-flex"> 
                                    <v-expansion-panels class="my-4" v-model="panel" :popout="true" focusable multiple
                                                        :hover="true">
                                        <v-expansion-panel v-for="(pendiente, i) in pendientes" :key="i" text=""
                                                           title="" active-class="activotl" id="bruh">
                                            <v-expansion-panel-header class="text-center" color="primary">
                                                <template v-slot:default>
                                                    <span class="card-title-text" style="font-size:17px;">
                                                        <b>Teléfono:</b>{{
 `
                                                        ${pendiente.NumeroTel} `
                                                        }}
                                                    </span>
                                                    <span class="grow"> </span>
                                                    <span class="card-title-text" style="font-size:18px;">
                                                        <b>Fecha:</b> {{
`
                                                        ${pendiente.FechaRecibido} `
                                                        }}
                                                    </span>
                                                </template>
                                            </v-expansion-panel-header>

                                            <!-- para tamaños grandes -->
                                            <v-expansion-panel-content>
                                                <v-list nav dense>
                                                    <v-list-item-group color="primary">
                                                        <!-- Encabezado -->
                                                        <div style="margin: auto;">
                                                            <v-list-item v-on:click.stop>
                                                                <v-list-item-content>
                                                                    <v-list-item-title class="text-center">
                                                                        <div class="grid" style="grid-template-columns: 10% 40% 40% 10%;">
                                                                            <span style="font-weight: bold;">Reporte</span>
                                                                            <span style="font-weight: bold;">Asistencia</span>
                                                                            <span style="font-weight: bold;">Cliente</span>
                                                                            <span style="font-weight: bold;">Actor</span>
                                                                        </div>
                                                                    </v-list-item-title>
                                                                    <v-divider></v-divider>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                        </div>
                                                        <div style="margin: auto;">
                                                            <v-list-item v-for="(r, i) in pendiente.reportes" :key="i"
                                                                         @click="VerReporte(r)"
                                                                         :style="i % 2 ? 'background-color: rgba(169, 182, 255, 0.18);' : ''">

                                                                <v-list-item-content>
                                                                    <v-list-item-title class="text-center">
                                                                        <div class="grid" style="grid-template-columns: 10% 40% 40% 10%;">
                                                                            <span>
                                                                                {{`${r.nrreporte}-${r.svindice}`}}
                                                                            </span>
                                                                            <span style="overflow: hidden;">{{r.tipoAsistencia}}</span>
                                                                            <span style="overflow: hidden;">{{r.cliente}}</span>
                                                                            <span style="text-align: center;">
                                                                                {{ r.actor }}
                                                                            </span>
                                                                        </div>
                                                                    </v-list-item-title>
                                                                    <v-divider></v-divider>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                        </div>

                                                    </v-list-item-group>
                                                </v-list>
                                            </v-expansion-panel-content>

                                        </v-expansion-panel>
                                    </v-expansion-panels>
                                </div>

                            </template>



                        </v-col>
                    </v-row>

                </v-card-text>
            </v-form>
        </v-card>
    </v-container>
</template>
<script>



import { mapState } from 'vuex';
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
import DataTable from "@/components/pages/DataTableNet/DataTable";
import WAService from '@/services/Whatsapp/Whatsapp.service.js';
    export default {
        title() {
            return this.$route.meta.title
        },
    data() {
        return {
            showcargando: false,
            pendientes: [],
            panel: null,
            telefonosSinRepetir: []
        }
    },
    components: {
        DataTable
    },

    computed: {
        ...mapState(['permission', 'domain']),
    },
    methods: {
        async ObtenerPendientes() {
            this.pendientes = await WAService.ObtenerPendientes().catch((e) => {
            })

            this.pendientes.forEach((p) => {
                let arr = p.Informacion.split('|')
                p.reportes = []
                arr.forEach((e) => {
                    let arr2 = e.split('-')
                    p.reportes.push({
                        nrreporte: Number(arr2[0]),
                        svindice: Number(arr2[1]),
                        reporte: `${arr2[0]}-${arr2[1]}`,
                        actor: arr2[2],
                        aiclave: Number(arr2[3]),
                        svfhcerrado: arr2[4],
                        cliente: arr2[5],
                        tipoAsistencia: arr2[6],
                    })
                })
            })
        },
        async VerReporte(reporte) {

            const reporteAux = { ...reporte }
            delete reporteAux.actor

            await MetodosGenerales.guardarEnSesionInfoReporte(reporteAux, 'reporte');

            const url = this.$router.resolve({ name: `${"Whatsapp"}` });
            window.open(url.href, '_blank');

        }


    },
    async beforeMount() {
        await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '358').then(response => {
            if (!response.data.length > 0) {
                this.$router.push({ name: `NoAutorizado` }).catch(error => error);
            }

        });
    },
        async mounted() {
            this.showcargando = true;
            await this.ObtenerPendientes();
            this.panel = [...Array(this.pendientes.length).keys()].map((k, i) => i)

            this.showcargando = false;
    },
    beforeUpdate() {

    },
}
</script>

<style scoped>


</style>

<style lang="scss" scoped>

.v-expansion-panel>.v-expansion-panel-header {
    background-color: #536dfe;
    color: white;
}

.v-icon::before, .v-icon::after{
    color: white !important; 
}


i{
    color: white !important; 
}

.v-expansion-panels .v-expansion-panel-header .v-expansion-panel-header__icon .v-icon {
    color: #FFFFFF !important;
}

.v-icon.v-icon{
    color: white !important; 
}


</style>
